import { useThemeMode } from 'web-shared/modules/UserPreferences/hooks/useThemeMode';
import { THEME_TYPE } from '../../consts';
import useMixedThemePageDetector from '../useMixedThemePageDetector';

const useThemeType = (defaultTheme: THEME_TYPE) => {
  const preferredTheme = useThemeMode();
  const { isMixedPage } = useMixedThemePageDetector();

  return isMixedPage ? defaultTheme : preferredTheme;
};

export default useThemeType;